import { Button, CodeCopy } from '@ahmdigital/ui';
import { kebabCase } from 'lodash/fp';
import styled from 'styled-components';

import constants from '../../../../../ahm-constants';

type PromoCodeProps = {
  codeType?: string;
  displayFullWidth?: boolean;
  promoCode?: string;
  promoCodeDescription?: string;
  referralUrl?: string;
  showCodeCopy: boolean;
  showMemberLogin: boolean;
};

const CodeCopyStyled = styled(CodeCopy)<{ displayFullWidth?: boolean }>`
  width: auto;

  @media (min-width: ${({ theme }) => theme.media.lg}) {
    width: ${({ displayFullWidth }) => (displayFullWidth ? 'auto' : '20rem')};
  }
`;

const PromoCode = ({
  codeType,
  displayFullWidth = false,
  promoCode,
  promoCodeDescription,
  referralUrl,
  showCodeCopy,
  showMemberLogin,
}: PromoCodeProps) => {
  if (showMemberLogin) {
    return <Button to={constants.URLS.MEMBERS.REFER_A_FRIEND}>Log in & get your referral code</Button>;
  }

  if (showCodeCopy && promoCode) {
    return (
      <CodeCopyStyled
        displayFullWidth={displayFullWidth}
        labelId={`code-copy-label-for-${kebabCase(promoCode)}`}
        codeValue={referralUrl || promoCode}
        label={promoCodeDescription}
        title={`Copy ${codeType} code`}
      />
    );
  }

  return null;
};

export default PromoCode;
